import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../app/hooks/useAuth'
import { UserRoleEnum } from '@/app/services/usersService/user'

export function ContentGuard() {
  const { user } = useAuth()

  if (!user?.role) return

  if (
    [UserRoleEnum.SUPER_ADMIN, UserRoleEnum.ADMIN].includes(user.role) ||
    [UserRoleEnum.SUPPORT].includes(user.secondRole)
  )
    return <Outlet />

  return (
    <Navigate
      to={
        [UserRoleEnum.SUPPORT].includes(user.secondRole)
          ? '/support'
          : '/transacoes'
      }
      replace
    />
  )
}
